<template>
  <b-modal
      modal-class="dynamic-attributes-modal"
      id="bv-modal-dynamic-attributes"
      ref="modal"
      title="Update Product Dynamic Attributes"
  >
    <div class="pl-3">
      <span>{{tr('valueAttributes','Value Attributes')}}</span>
    </div>
    <RowsGroupRenderer
        :validated-field="validatedField"
        :fieldConfig="fieldConfig"
        :parent-form="productFormModel"
        :master-form-model="productFormModel"
        :hasCustomFieldLabel="true"
        mode="EDIT"
        :fields-filter="fieldsFilter"
    ></RowsGroupRenderer>

    <template #modal-footer>
      <div class="w-100 text-center m-0">
        <FooterNavbar>
          <footer-button type="Cancel" @cancel="cancel"></footer-button>
          <FooterButton type="Save" :label="saveLabelButton" @save="save"></FooterButton>
        </FooterNavbar>
      </div>
    </template>
  </b-modal>

</template>

<script>

import VBox from "@/components/VBox";
import ReachInput from "@/components/inputs/ReachInput";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import RowsGroupRenderer from "@/components/forms/renderers/RowsGroupRenderer";
import {SAVE_AND_CLOSE_LABEL} from "@/components/navbar/ButtonLabel";
import tr from "../../utils/Tr";


export default {
  name: "UpdateDynamicAttributesDialog",
  components: {RowsGroupRenderer, FooterButton, FooterNavbar, ReachInput, VBox, CloseButton},

  methods: {
    tr,


    async cancel() {
      this.$refs.modal.hide();
    },

    loadDynamicAttributes(){
      if(this.dynamicAttributes){
        this.validatedField.value = [];
        for(let dynAttr of this.dynamicAttributes) {
          this.validatedField.value.push(dynAttr);
        }
      }
    },

    async save() {
      await Rpc.plm.services.ProductService.bulkEditDynamicAttributes(this.selectedItems, this.validatedField.value).lock();
      this.$refs.modal.hide();
    },

  },

  props: {},

  data: () => ({
    result: null,
    validatedField: null,
    dynamicAttributes: null,
    fieldConfig: null,
    context: null,
    mode: null,
    productFormModel: null,
    selectedItems: [],
    saveLabelButton: $tr("Save", "Save"),
    fieldsFilter: function (val) {
      return val.fieldName !== "order";
    }
  })
}
</script>


<style>

.dynamic-attributes-modal .modal-dialog {
  max-width: 100%;
}

.dynamic-attributes-modal .modal-footer {
  border: none;
  padding: 0
}

@media (min-width: 768px) {
  .dynamic-attributes-modal .modal-dialog {
    max-width: 80%
  }
}

@media (min-width: 1024px) {
  .dynamic-attributes-modal .modal-dialog {
    max-width: 60%
  }
}

</style>
